module.exports = __webpack_public_path__ + "img/send out.62a42f62.svg";